import { selectCurrentHotelName } from 'accessors'
import { postAndSelectSubsidiary } from 'actions'
import { SecondarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import { hotelSetupSteps } from 'features/HotelSetup'
import ActiveDot from 'features/HotelSetup/Header/ActiveDot'
import DoneDot from 'features/HotelSetup/Header/DoneDot'
import EmptyDot from 'features/HotelSetup/Header/EmptyDot'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { selectCurrentHotelId } from '../../../accessors/index'
import styles from './HotelSetupHeader.module.scss'

const ActiveStep = ({ name }) => (
  <div className={styles.step}>
    <ActiveDot />
    <p className={styles.activeStepTitle}>{name}</p>
  </div>
)

const EmptyStep = ({ name }) => (
  <div className={styles.step}>
    <EmptyDot />
    <p className={styles.stepTitle}>{name}</p>
  </div>
)

const DoneStep = ({ name }) => (
  <div className={styles.step}>
    <DoneDot />
    <p className={styles.stepTitle}>{name}</p>
  </div>
)

const HotelSetupHeader = ({ step, isSetupCompleted }) => {
  const currentHotelName = useSelector(selectCurrentHotelName)
  const currentSubsidiaryId = useSelector(selectCurrentHotelId)
  const history = useHistory()
  const dispatch = useDispatch()

  // async function handleLogOutFromHotel() {
  //   localStorage.removeItem('activeHotelMerchantId')
  //   dispatch({ type: 'LOG_OUT_FROM_CURRENT_HOTEL' })
  // }

  const handleExitSetupClick = () => {
    dispatch(postAndSelectSubsidiary(currentSubsidiaryId)).then(() => {
      history.push('/manageCampaigns/sales')
    })
  }

  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <div className={styles.headerText}>
          <div className={styles.title}>Hotel setup</div>
          <div className={styles.hotelName}>{currentHotelName}</div>
        </div>
        <div className={styles.progress}>
          <div className={styles.lines}>
            <div className={step > 1 ? styles.lineGood : styles.line} />
            <div className={step > 2 ? styles.lineGood : styles.line} />
          </div>
          <div className={styles.timeline}>
            {isSetupCompleted && (
              <>
                <DoneStep name="Addendum" />
                <DoneStep name="Hotel staff" />
                <DoneStep name="Legal info" />
              </>
            )}
            {!isSetupCompleted && step === hotelSetupSteps.Addendum && (
              <>
                <ActiveStep name="Addendum" />
                <EmptyStep name="Hotel staff" />
                <EmptyStep name="Legal info" />
              </>
            )}
            {!isSetupCompleted && step === hotelSetupSteps.HotelStaff && (
              <>
                <DoneStep name="Addendum" />
                <ActiveStep name="Hotel staff" />
                <EmptyStep name="Legal info" />
              </>
            )}
            {!isSetupCompleted && step === hotelSetupSteps.LegalInformation && (
              <>
                <DoneStep name="Addendum" />
                <DoneStep name="Hotel staff" />
                <ActiveStep name="Legal info" />
              </>
            )}
          </div>
        </div>
      </div>
      <div className={styles.headerControls}>
        <SecondarySmallButton onClick={handleExitSetupClick}>
          Exit setup
        </SecondarySmallButton>
      </div>
    </div>
  )
}

HotelSetupHeader.propTypes = {
  step: PropTypes.oneOf(['Addendum', 'HotelStaff', 'LegalInformation']).isRequired
}

export default HotelSetupHeader
